import {useCallback, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {requestSnapshot} from "../../../redux/Actions/controllers.actions";
import {
  snapshots,
  getSnapshotPaginationUrls,
  getSnapshotTotalCount,
} from "../../../redux/Selectors/controllers.selectors";

export const useGetSnapshots = () => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const snapshotsList = useSelector(snapshots);
  const snapshotTotalCount = useSelector(getSnapshotTotalCount);
  const snapshotUrls = useSelector(getSnapshotPaginationUrls);

  const loadSnapshots = useCallback(() => {
    dispatch(requestSnapshot());
  }, [dispatch]);

  useEffect(() => {
    loadSnapshots();
  }, [loadSnapshots]);

  const handlePageChange = (page) => {
    const url = currentPage < page ? snapshotUrls?.nextUrl : snapshotUrls?.prevUrl;
    dispatch(requestSnapshot(url));
    setCurrentPage(page);
  };

  const paginationConfig = {
    currentPage,
    onPageChange: handlePageChange,
  };

  return {loadSnapshots, paginationConfig, snapshotsList, snapshotTotalCount};
};
